export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Restablecer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar todo"])}
}